module.exports = __webpack_public_path__ + "static/media/color-interpolation.8a523178.png";